import { LucidServerAPI, createAdvancedSearchParams, makeParams } from '~api/api';
import * as apiUtils from '~api/api-utils';

export const searchApplications = (search) => {
  if (!search?.trim()) {
    return Promise.reject();
  }

  return LucidServerAPI().get('/applications', {
    params: createAdvancedSearchParams(search, [ 'name' ])
  });
};

export const getApplication = (appId) => {
  return LucidServerAPI().get(`/applications/${appId}`);
};

export const getApplications = (options = {}) => {
  return LucidServerAPI().get(`/applications${makeParams(options)}`);
};

export const getApplicationAuthorizations = (appId) => {
  return LucidServerAPI().get(`/applications/${appId}/authorization?count=100`);
};

export const getApplicationLogs = (appId) => {
  return LucidServerAPI().get(`/applications/${appId}/logs?count=1500`);
};

export const getApplicationMetrics = (appId, metricType, paramsList) => {
  return LucidServerAPI().get(`/applications/${appId}/metrics/${metricType}?${apiUtils.parameterizeArray(paramsList).toString()}`);
};

export const resumeApplication = (appId) => {
  return LucidServerAPI().patch(`/applications/${appId}/resume`);
};

export const deployApplication = (appId) => LucidServerAPI().patch(`/applications/${appId}/deploy`);

export const suspendApplication = (appId) => LucidServerAPI().patch(`/applications/${appId}/suspend`);

export const restartApplication = (appId) => LucidServerAPI().patch(`/applications/${appId}/restart`);

export const terminateApplication = (appId) => LucidServerAPI().patch(`/applications/${appId}/terminate`);

export const purgeApplication = (appId, options = {}) => LucidServerAPI().patch(`/applications/${appId}/purge`, options);

export const exportApplication = (appId) => LucidServerAPI().patch(`/applications/${appId}/export`);
